import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConnectionType } from 'connection';
import { SupportedLocale } from 'constants/locales';
import { twitterApi } from 'state/twitter/api';

const currentTimestamp = () => new Date().getTime();

export interface UserState {
  selectedWallet?: ConnectionType;

  // the timestamp of the last updateVersion action
  lastUpdateVersionTimestamp?: number;

  timestamp: number;

  matchesDarkMode: boolean; // whether the dark mode media query matches
  userDarkMode: boolean | null; // the user's choice for dark mode or light mode
  userLocale: SupportedLocale | null;

  twitterToken: string | null;
}

export const initialState: UserState = {
  selectedWallet: undefined,
  matchesDarkMode: false,
  userDarkMode: null,
  userLocale: null,
  timestamp: currentTimestamp(),
  twitterToken: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,

  reducers: {
    updateVersion(state) {
      state.lastUpdateVersionTimestamp = currentTimestamp();
    },
    updateUserLocale(state, action: PayloadAction<{ userLocale: SupportedLocale }>) {
      state.userLocale = action.payload.userLocale;
      state.timestamp = currentTimestamp();
    },
    updateSelectedWallet(state, { payload: { wallet } }) {
      state.selectedWallet = wallet;
    },
    logOutTwitter(state) {
      state.twitterToken = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(twitterApi.endpoints.getTwitterToken.matchFulfilled, (state, { payload }) => {
      state.twitterToken = payload.token;
    });
  },
});

export const { updateUserLocale, updateSelectedWallet, logOutTwitter } = userSlice.actions;

export default userSlice.reducer;
